<ion-list class="ion-no-margin ion-no-padding">
  <ion-item button [disabled]="!hasGrantToWriteImplement" id="open-modal" expand="block">{{ "BEACON.ASSIGN" | translate }}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteImplement" (click)="onClickEdit()">{{'EDIT'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteImplement" *ngIf="!implementDto.active" (click)="onClickActivate()">{{'ACTIVATE'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteImplement" *ngIf="implementDto.active" (click)="onClickDeactivate()">{{'DEACTIVATE'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteImplement" *ngIf="!implementDto.deleted" (click)="onClickDelete()">{{'DELETE'|translate}}</ion-item>
</ion-list>

<ion-modal 
[initialBreakpoint]="1"
[breakpoints]="[0, 1]"
#modal trigger="open-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{'BEACON.ASSIGN'|translate}}</ion-title>
        <ion-buttons slot="start">
          <ion-button (click)="modal.dismiss()"><span>{{'CANCEL'|translate}}</span></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-searchbar debounce="500" (ionInput)="onSearch($event)"></ion-searchbar>
      <ion-list>
        <ion-item *ngFor="let beacon of beaconsList" (click)="selectBeacon(beacon.mac)">
          <div>
            <p>{{beacon.serial}}</p>
            <p class="machine_name"><span *ngIf="beacon.implement?.name"> {{beacon.implement.name}} </span>
            <span *ngIf="beacon.implement?.make && beacon.implement?.model && !beacon.implement?.name"> {{beacon.implement.make}} {{beacon.implement.model}} </span>
            </p>
            </div>
        </ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>

